
import Img from '@/images';

import styles from './styles.module.scss';

const HiringEasierBottomShape = () => (
    <Img className={styles['bottom-shape']} src="static/images/free-tools-for-managers/decorative/hiring-easier-shapes-bottom.png" />
);


export default HiringEasierBottomShape;
